<template>
  <main class="conditions">
    <div class="text">
      <div class="li flex" v-for="text in sizeGuide" :key="text.title">
        <div class="sli top">{{ text.title }}</div>
        <div class="sli" v-html="text.text"></div>
      </div>
    </div>
    <div class="sizes flex ai-t">
      <div class="li flex f-c b-r">
        <div class="pad b-b">All measurements are in cm</div>
        <div class="pad b-b">XS</div>
        <div class="pad b-b">S</div>
        <div class="pad b-b">M</div>
        <div class="pad b-b">L</div>
        <div class="pad">XL</div>
      </div>
      <div class="li flex f-c b-r t-c">
        <div class="pad b-b">Chest</div>
        <div class="pad b-b">82</div>
        <div class="pad b-b">90</div>
        <div class="pad b-b">98</div>
        <div class="pad b-b">106</div>
        <div class="pad">112</div>
      </div>
      <div class="li flex f-c b-r t-c">
        <div class="pad b-b">Waist</div>
        <div class="pad b-b">64</div>
        <div class="pad b-b">70</div>
        <div class="pad b-b">78</div>
        <div class="pad b-b">86</div>
        <div class="pad">92</div>
      </div>
      <div class="li flex f-c b-r t-c">
        <div class="pad b-b">Hip</div>
        <div class="pad b-b">90</div>
        <div class="pad b-b">96</div>
        <div class="pad b-b">104</div>
        <div class="pad b-b">110</div>
        <div class="pad">116</div>
      </div>
      <div class="li flex f-c b-r t-c">
        <div class="pad b-b">Inside leg</div>
        <div class="pad b-b">75</div>
        <div class="pad b-b">76</div>
        <div class="pad b-b">81</div>
        <div class="pad b-b">86</div>
        <div class="pad">87</div>
      </div>
      <div class="li flex f-c t-c">
        <div class="pad b-b">Sleeve</div>
        <div class="pad b-b">56</div>
        <div class="pad b-b">57</div>
        <div class="pad b-b">59</div>
        <div class="pad b-b">62</div>
        <div class="pad">63</div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "size-guide",
  data() {
    return {
      lang: "en"
    };
  },
  created() {
    if (this.$store.state.sizeguide.length === 0) {
      this.$store.dispatch("loadSizeGuide");
    }
  },
  computed: {
    sizeGuide() {
      return this.$store.state.sizeguide;
    }
  }
};
</script>

<style lang="scss" scoped>
.conditions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: var(--lh);
  .top {
    white-space: nowrap;
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    .top {
      white-space: normal;
    }
  }
}
</style>
